module.exports = __webpack_public_path__ + "img/m_zljc.2f61c48a.png";